import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';

import css from './BecomeHostPage1.module.css';
import { FormattedMessage } from '../../util/reactIntl';

const close = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082945/socialbnb/containers/BecomeHostPage1/close.png';

const emails = ['username@gmail.com', 'user02@gmail.com'];

function SimpleDialog(props) {
  const { onClose, selectedValue, open } = props;
  const handleClose = () => {
    onClose(selectedValue);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}

    //maxWidth="100vw"
    //style={{ minWidth: '90vw', margin: 0 }}
    >
      <div className={css.popUp}>
        <button onClick={handleClose} className={css.popUpCloseButton}>
          <img src={close} className={css.popUpCloseImg} alt="Close Button - Socialbnb"></img>
        </button>
        <h2 className={css.popUpTitel}>
          <FormattedMessage id="becomeHost.page2.language" />
        </h2>
        <a
          className={css.heroButton2}
          href="https://events.teams.microsoft.com/event/689475cf-294a-48b5-8658-d4e4a953ca84@a42a038d-458e-4f70-8167-359877fb0d73"
          target="blank"
          data-elbaction={'click:click becomehostengbtn'}
        >
          English
        </a>
        <a
          className={css.heroButton2}
          href="https://events.teams.microsoft.com/event/1c7235e5-28e8-47a0-9dd8-33548c9e1ca4@a42a038d-458e-4f70-8167-359877fb0d73"
          target="blank"
          data-elbaction={'click:click becomehostspabtn'}
        >
          Spanish
        </a>
      </div>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

export default function SimpleDialogDemo() {
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(emails[1]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = value => {
    setOpen(false);
    setSelectedValue(value);
  };

  return (
    <div>
      {' '}
      <a href="mailto:partner@socialbnb.de" className={css.heroButton} data-elbaction={'click:click regstformeeting'}>
        <FormattedMessage id="becomeHost.page2.button" />
      </a>
      <SimpleDialog selectedValue={selectedValue} open={open} onClose={handleClose} />
      {/* <div style={{ textAlign: 'center' }}>
        <FormattedMessage
          id={'contactForm.alternativeSend'}
          values={{
            partnerEmail: (
              <a className={css.mailToBtn} href="mailto:partner@socialbnb.de">
                partner@socialbnb.de
              </a>
            ),
          }}
        />
      </div> */}
    </div>
  );
}
